import axiosI from '@/api/base.api';
import { buildApiMutationHook, buildApiQueryHook } from '@/utils/api';
import { queryClient } from '@/utils/queryClient';
import { AuctionCharityDto, SubmitAuctionCharityParticipationResponse } from './auctionCharity.dto';
export type CreateAuctionCharityBody = {
  title: string | null;
  description: string | null;
  scheduleItemsAt: Date;
  startItemsAt: Date;
  endItemsAt: Date;
  items: {
    showcaseItem: {
      id: number;
    };
  }[];
};

export type EditAuctionCharityBody = {
  title: string | null;
  description: string | null;
  id: number;
};

export type SubmitAuctionCharityParticipationBody = {
  auctionCharityId: number;
  items: {
    id: number;
    status: 'confirmed' | 'denied';
  }[];
};

export type AuctionCharityRemoveItemsBody = {
  auctionCharityId: number;
  items: {
    id: number;
  }[];
};

export type AuctionCharityAddItemsBody = {
  auctionCharityId: number;
  items: {
    showcaseItem: {
      id: number;
    };
  }[];
};

export type GetAuctionCharityByIdParams = {
  auctionCharityId: number;
};

export const invalidateAuctionCharityQueryById = (id: number) => {
  queryClient.invalidateQueries(['auction-charity', id]);
};
export const useScheduleAuctionCharityMutation = buildApiMutationHook<
  CreateAuctionCharityBody,
  {
    auctionCharity: AuctionCharityDto;
    notFoundItems: number[];
  }
>((data) => axiosI.post('/auction/charity/create', data));

export const useEditAuctionCharityMutation = buildApiMutationHook<
  EditAuctionCharityBody,
  {
    auctionCharity: AuctionCharityDto;
    notFoundItems: number[];
  }
>((data) => axiosI.post('/auction/charity/edit', data));

export const useSubmitAuctionCharityParticipationMutation = buildApiMutationHook<
  SubmitAuctionCharityParticipationBody,
  SubmitAuctionCharityParticipationResponse
>((data) => axiosI.post('/auction/charity/submit-participation', data));

export const useAuctionCharityRemoveItemsMutation = buildApiMutationHook<
  AuctionCharityRemoveItemsBody,
  void
>((data) => axiosI.post('/auction/charity/remove-items', data));

export const useAuctionCharityAddItemsMutation = buildApiMutationHook<
  AuctionCharityAddItemsBody,
  {
    notFoundItems: number[];
  }
>((data) => axiosI.post('/auction/charity/add-items', data));

export const useGetAuctionCharityByIdQuery = buildApiQueryHook<
  GetAuctionCharityByIdParams,
  AuctionCharityDto
>(
  ({ auctionCharityId }) => ['auction-charity', auctionCharityId],
  ({ auctionCharityId }) => axiosI.get(`/auction/charity/get/${auctionCharityId}`),
);

export type GetAuctionCharityListParams = {
  userId?: number;
  offset?: number;
  limit?: number;
};

export const useGetAuctionCharityListQuery = buildApiQueryHook<
  GetAuctionCharityListParams,
  {
    count: number;
    rows: AuctionCharityDto[];
  }
>(
  (params) => ['auction-charity-list', params.userId],
  (params) => axiosI.get('/api/auction/charity/list', { params }),
);
